export default __webpack_public_path__ + "static/media/light-light-theme-icon.84064bf8.svg";